
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontalChargingEmpty as ObiBatteryHorizontalChargingEmptyElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-charging-empty.js';
 
 
 

 
 export const ObiBatteryHorizontalChargingEmpty = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-charging-empty',
   elementClass: ObiBatteryHorizontalChargingEmptyElement,
   events: {
     
   }
  });
 
 